import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { ADMIN_OR_ABOVE_ROLES } from "@/src/reports/constants/reports.constants";
import { REPORTS_ROUTES } from "@/src/reports/constants/reports-routes.constants";

const ReportsPage = lazy(() => import("@/src/reports/pages/reports.page"));

export const reportsRoutes: RouteObject[] = [
	{
		element: <ProtectedRoute requiredRole={[...ADMIN_OR_ABOVE_ROLES]} />,
		children: [{ path: REPORTS_ROUTES.reports, element: <ReportsPage /> }],
	},
];
